/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Cta_NoteInputs */

const en_projects_cta_note = /** @type {(inputs: Projects_Cta_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A 30-minute conversation. No technical brief needed.`)
};

const lv_projects_cta_note = /** @type {(inputs: Projects_Cta_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 minūšu saruna. Tehnisks apraksts nav vajadzīgs.`)
};

/**
* | output |
* | --- |
* | "A 30-minute conversation. No technical brief needed." |
*
* @param {Projects_Cta_NoteInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const projects_cta_note = /** @type {((inputs?: Projects_Cta_NoteInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Cta_NoteInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_projects_cta_note(inputs)
	return en_projects_cta_note(inputs)
});